import { VehicleSummaryView } from '@mark43/dex-api';
import { VStack, Card, CardBody, CardHeader, Text, DataList, DataItem } from '@cad-arc';
import { compact } from 'lodash';

export function DexVehicleResultSummary({ vehicle }: { vehicle: VehicleSummaryView }) {
    const summary = compact([
        vehicle.vehicleYear,
        vehicle.vehicleColorCode,
        vehicle.vehicleMakeCode,
        vehicle.vehicleModelCode,
    ]).join(' ');
    return (
        <Card>
            <CardHeader title="Vehicle" />
            <CardBody>
                <VStack align="left">
                    <Text variant="headingSm">{summary}</Text>
                    <DataList>
                        <DataItem dataKey="Registration Status">
                            {vehicle.registrationStatusCode}
                        </DataItem>
                        <DataItem dataKey="Model">{vehicle.vehicleModelCode}</DataItem>
                        <DataItem dataKey="Issue">{vehicle.issueDate}</DataItem>
                        <DataItem dataKey="Make">{vehicle.vehicleMakeCode}</DataItem>
                        <DataItem dataKey="Color">{vehicle.vehicleColorCode}</DataItem>
                    </DataList>
                </VStack>
            </CardBody>
        </Card>
    );
}
